import { render } from "./Client_Categories.vue?vue&type=template&id=eda21bcc"
import script from "./Client_Categories.vue?vue&type=script&lang=js"
export * from "./Client_Categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__